import request from '@/http'
export const customUpload = (params) => {
  const formData = new FormData()
  formData.append('file', params.file)
  request.addFile(formData, params).then(({ data }) => {
    if(data.code ===200) {
      params.onSuccess(data)
    } else {
      params.onError(data.msg)
    }
  }).catch(err => {
    params.onError(err)
  })
}